/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="90.05"
        height="95.55"
        viewBox="0 0 90.05 95.55"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M43.39 40.97A10.92 10.92 0 1 0 54.3 51.9a10.9 10.9 0 0 0-10.91-10.91Zm0 2.5a8.42 8.42 0 1 1-8.42 8.42 8.41 8.41 0 0 1 8.42-8.38ZM53.05 68.4a1.25 1.25 0 0 1 1.32 1.18 1.27 1.27 0 0 1-1.19 1.32H33.91a7.89 7.89 0 0 0-7.9 7.66v1.61a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.11v-1.49a10.42 10.42 0 0 1 10.13-10.4h19.4ZM70.22 55.13a10.92 10.92 0 1 0 10.91 10.93 10.91 10.91 0 0 0-10.91-10.93Zm0 2.5a8.42 8.42 0 1 1-8.42 8.42 8.42 8.42 0 0 1 8.42-8.42ZM79.65 82.57a10.39 10.39 0 0 1 10.4 10.12v1.64a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-1.49a7.89 7.89 0 0 0-7.66-7.9H60.69a7.89 7.89 0 0 0-7.9 7.66v1.6a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-1.49a10.42 10.42 0 0 1 10.13-10.4h19.22ZM36.28 0h-29A7.28 7.28 0 0 0 0 7.28v18.74a7.34 7.34 0 0 0 7.28 7h12.88l9.44 8 .09.07a1.26 1.26 0 0 0 1.75-.25 1.27 1.27 0 0 0 .25-.75v-7h4.63a7.28 7.28 0 0 0 7.19-7.28V7.28A7.27 7.27 0 0 0 36.28 0Zm-29 2.5h29a4.77 4.77 0 0 1 4.77 4.78v18.5a4.77 4.77 0 0 1-4.76 4.78h-6a1.24 1.24 0 0 0-1.13 1.24v5.61l-7.73-6.56a1.15 1.15 0 0 0-.81-.3H7.29a4.84 4.84 0 0 1-4.78-4.77V7.28A4.78 4.78 0 0 1 7.29 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M12.22 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49M21.78 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49M31.36 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleOneWordBubbleIcon';

export default Icon;
